import axios from 'axios';
import Map from '../../components/map/map';
import Select from '../../components/select/select';
import {getUrlParameter} from '../../utils/helpers';

export default class contactUs {
    constructor() {
        this.map = this.initMap();
        this.sectionSelect = new Select(document.querySelector('.select[data-id="sections"]'));
        this.subSectionSelect = new Select(document.querySelector('.select[data-id="subsections"]'));
        this.contactPersonsHolder = document.querySelector('.contactPersonsHolder');
        this.contactPersons = [];

        this.section = 'all';
        this.subSection = 'all';

        this.setInitialFilter();
        this.getContactPersons();
        this.bindEvents();
    }

    setInitialFilter() {
        let section = getUrlParameter('section');
        let subsection = getUrlParameter('subsection');

        if (!section) {
            section = 'all';
        }

        if (!subsection) {
            subsection = 'all';
        }

        this.section = section;
        this.subSection = subsection;

        this.sectionSelect.setActiveItemFromSlug(section);
        this.subSectionSelect.setActiveItemFromSlug(subsection);
    }

    initMap() {
        const mapEl = document.querySelector('.map');
        return new Map(mapEl, window.cords);
    }

    bindEvents() {
        this.sectionSelect.on('changed', (value) => this.sectionChanged(value));
        this.subSectionSelect.on('changed', (value) => this.subSectionhanged(value));
    }

    sectionChanged(value) {
        this.section = value;
        this.filter();
    }

    subSectionhanged(value) {
        this.subSection = value;
        this.filter();
    }

    filter(updateUrl = true) {
        let items = this.contactPersons;
        const filtered = [];

        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if (this.hasCurrentSection(item) && this.hasCurrentSubSection(item)) {
                filtered.push(item);
            }
        }

        this.render(filtered);
        if (updateUrl) {
            this.updateUrl();
        }
    }

    hasCurrentSection(item) {
        if (this.section === 'all') return true;

        const sections = item.sections;

        for (let i = 0; i < sections.length; i++) {
            if (sections[i].slug === this.section) {
                return true;
            }
        }

        return false;
    }

    hasCurrentSubSection(item) {
        if (this.subSection === 'all') return true;

        const subSections = item.subsections;

        for (let i = 0; i < subSections.length; i++) {
            if (subSections[i].slug === this.subSection) {
                return true;
            }
        }

        return false;
    }

    getContactPersons() {
        const self = this;

        axios.get('/contactPersons')
        .then(function(response) {
            self.contactPersons = response.data;
            self.filter(false);
        })
        .catch(function(error) {
            console.log(error);
        });
    }

    render(posts) {
        const html = this.getHtml(posts);
        this.contactPersonsHolder.innerHTML = html;
    }

    getHtml(posts) {
        if (posts.length < 1) {
            return `<p class="searchErrorMessage">${window.errorMessage}</p>`;
        }

        let html = '';

        for (let i = 0; i < posts.length; i++) {
            html += posts[i].html;
        }

        return html;
    }

    updateUrl() {
        let url = this.getNewUrl();
        window.history.replaceState(null, null, url);
    }

    getNewUrl() {
        let url = window.location.href.split('?')[0];

        if (this.section !== 'all' && this.subSection !== 'all') {
            url += `?section=${this.section}&subsection=${this.subSection}`;
        } else if (this.section !== 'all') {
            url += `?section=${this.section}`;
        } else if (this.subSection !== 'all') {
            url += `?subsection=${this.subSection}`;
        }

        return url;
    }
}



// WEBPACK FOOTER //
// ./src/pages/contactUs/contactUs.js